import { PanelBody, TextControl, TextareaControl, ToggleControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { produce } from "immer";
import BControlPro from "../../../../components/BControlPro";

const EndScreen = ({ isPremium, attributes, panelRef, handleFeatures }) => {
  const { enabled, text, btnLink, btnText, btnStyle } = attributes.features.endScreen;

  // const updateEndScreen = (key, value) => {
  //   const newEndScreen = produce(endScreen, (draft) => {
  //     draft[key] = value;
  //   });
  //   setAttributes({ endScreen: newEndScreen });
  // };

  const handleEndScreen = (value) => {
    console.log(value);
    handleFeatures(
      produce(attributes.features.endScreen, (draft) => {
        draft.enabled = enabled;
        Object.keys(value).map((key) => {
          draft[key] = value[key];
        });
      }),
      "endScreen"
    );
  };

  return (
    <PanelBody ref={panelRef} title={__("End Screen", "h5vp")} initialOpen={false}>
      <BControlPro
        isPremium={isPremium}
        Component={ToggleControl}
        label={__("Enabled", "bpm")}
        id="endscreen"
        checked={enabled}
        onChange={() => handleEndScreen({ enabled: !enabled })}
        help={__("Repeat should be disabled", "h5vp")}
      />

      {enabled && (
        <>
          <TextareaControl label={__("Text", "h5vp")} value={text} onChange={(text) => handleEndScreen({ text })} />

          <TextControl label={__("Button Text", "h5vp")} value={btnText} onChange={(btnText) => handleEndScreen({ btnText })} />
          <TextControl label={__("Button link", "h5vp")} value={btnLink} onChange={(btnLink) => handleEndScreen({ btnLink })} />
        </>
      )}
    </PanelBody>
  );
};

export default EndScreen;
